export const attendanceMutations = {};
